import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=2f760ee5&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=2f760ee5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f760ee5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f760ee5')) {
      api.createRecord('2f760ee5', component.options)
    } else {
      api.reload('2f760ee5', component.options)
    }
    module.hot.accept("./userDetails.vue?vue&type=template&id=2f760ee5&scoped=true", function () {
      api.rerender('2f760ee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/historical/user-details-view/userDetails.vue"
export default component.exports